import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AskOurDataService } from '@app/core/services/ask-our-data/ask-our-data.service';
import { ActivatedRoute } from '@angular/router';
import { SamplePrompt } from '@shared/models/ask-our-data.model';
import { Messages } from '@app/shared/constants/ask-our-data-constants';
import { featureFlags } from '@app/environments/environment';

@Component({
    selector: 'app-sample-prompts',
    templateUrl: './sample-prompts.component.html',
    styleUrl: './sample-prompts.component.css',
    standalone: false
})
export class SamplePromptsComponent implements OnInit{
  dbname: string= '';
  dbId: string = '';
  @Input() userName: string = '';
  @Output() samplePromptSelectEvent = new EventEmitter<SamplePrompt>();
  @Input() showHeaderMessage: boolean = true;
  @Output() samplePromptsEvent = new EventEmitter<SamplePrompt[]>();
  samplePrompts: SamplePrompt[] = [];
  selectedChip: any = '';
  samplePromptTitleText = 'Enter a prompt in the chat box below or try one of our sample prompts.';
  normalTitleText = 'Enter a prompt in the chat box below';
  showSamplePrompts: boolean = true;
  showTitle: boolean = false;
  protected readonly featureFlags = featureFlags;

  constructor(
      private askOurDataService: AskOurDataService,
      private route: ActivatedRoute,
  ){ }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.dbId = params['id'];
      this.dbname = params['name'];
    });
    this.userName = this.getUserName(this.userName);
    this.getPrompts();
  }

  getUserName(name: string): string {
    const nameParts = name.includes(',') 
      ? name.split(',')[1]?.trim().split(' ') 
      : name.split(' ');

    const firstName = nameParts?.[0];
    return firstName ? ` ${firstName}` : '';
  }

  samplePromptSelected(samplePrompt: SamplePrompt) {
    this.selectedChip = samplePrompt;
    this.samplePromptSelectEvent.emit(samplePrompt);
    setTimeout(() => {
      this.selectedChip = null;
    }, 100);
  }
  
  getPrompts() {
    this.askOurDataService.getSamplePrompts(Number(this.dbId),  Messages.NUMBER_OF_SAMPLE_PROMPTS_FOR_CHAT).subscribe({
      next: (response) => {
        this.showTitle = true;
        if(response.sample_prompts.length === 0) {
          this.showSamplePrompts = false;
        }
        this.samplePrompts = response.sample_prompts.map((prompt: SamplePrompt) => ({
          title: (prompt.title || '')?.trim().replace(/\s+/g, ' '),
          question: prompt.question?.trim().replace(/\s+/g, ' '),
          sql: prompt.sql?.trim()
        }));
        this.samplePromptsEvent.emit(this.samplePrompts);
      },
      error: () => {
        this.showTitle = true;
        this.showSamplePrompts = false;
        this.samplePromptsEvent.emit([]);
      }
    });
  }
}